import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '../AuthContext.jsx';
import { supabase } from '../supabase.js';
import { formatMoney, requestPayments, settled, statusLabel } from './api.js';
import { SignInGate } from '../SignIn.jsx';

const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/** Where Stripe checkout sends the customer back. The page asks the server; the URL itself proves nothing. */
export default function PaymentReturnPage() {
  const { user, loading } = useAuth();
  const [params] = useSearchParams();
  const invoiceId = params.get('invoice') || '';
  if (loading) return <div className="content-wrap"><p>Loading account…</p></div>;
  if (!user || !supabase) return <SignInGate next="/work"/>;
  if (!uuidPattern.test(invoiceId)) return <div className="content-wrap account-page"><h1>Payment</h1><p>This payment link is not valid. See your <Link to="/work">agreed work</Link>.</p></div>;
  return <ReturnStatus key={`${user.id}:${invoiceId}`} invoiceId={invoiceId} cancelled={params.get('cancelled') === '1'} />;
}

function ReturnStatus({ invoiceId, cancelled }) {
  const [invoice, setInvoice] = useState(null);
  const [error, setError] = useState('');
  const [version, setVersion] = useState(0);
  useEffect(() => {
    let current = true;
    requestPayments(supabase, 'refresh-job-payment', { invoiceId }).then((value) => { if (current) { setInvoice(value.invoice); setError(''); } },
      (cause) => { if (current) setError(cause.message); });
    return () => { current = false; };
  }, [invoiceId, version]);
  let message = 'Checking your payment with Stripe…';
  if (invoice && settled(invoice.status)) message = 'Payment confirmed. Thank you.';
  else if (invoice && cancelled) message = "Payment cancelled. You haven't been charged.";
  else if (invoice) message = 'Your payment has not been confirmed yet. This can take a moment.';
  return <div className="content-wrap account-page"><header className="coord-page-heading"><div><span className="account-kicker">PAYMENT</span><h1>{invoice ? statusLabel(invoice.status) : 'Payment'}</h1><p role="status">{message}</p></div></header>
    {invoice && <section className="account-content-panel"><h2>{invoice.title}</h2><p>{invoice.sellerLegalName} · {formatMoney(invoice.amountMinor, invoice.currency)}</p></section>}
    {error && <p role="alert">{error}</p>}
    <div className="coord-inline-actions">
      {(!invoice || !settled(invoice.status)) && <button className="button button-secondary" onClick={() => setVersion((value) => value + 1)}>Check again</button>}
      <Link className="button button-blue" to="/work">Back to agreed work</Link>
    </div>
  </div>;
}
